import React from "react";
import { Check } from "lucide-react";

export const LangPicker = ({ all = [], selected = [], onToggle, title = "Output Languages" }) => (
  <div className="rounded-xl border border-line bg-bg-surface p-4" data-testid="lc-lang-picker">
    <div className="font-mono text-[10px] uppercase tracking-[0.2em] text-ink-muted mb-3">{title}</div>
    <div className="space-y-1 max-h-72 overflow-y-auto pr-1">
      {all.map((l) => {
        const on = selected.includes(l.code);
        return (
          <button
            key={l.code} onClick={() => onToggle(l.code)} data-testid={`lc-lang-${l.code}`}
            className={`w-full flex items-center gap-2 rounded-md px-3 py-2 text-left text-sm transition ${
              on
                ? "bg-brand-amber/10 border border-brand-amber/40 text-ink-primary"
                : "border border-transparent text-ink-secondary hover:bg-bg-elevated"
            }`}
          >
            <span className="font-mono text-[9px] uppercase text-ink-muted w-9 shrink-0">{l.code}</span>
            <span className="flex-1 truncate">{l.name}</span>
            {l.tier === "caribbean" && (
              <span className="text-[8px] font-mono uppercase tracking-wider text-emerald-400">Caribbean</span>
            )}
            {on && <Check className="h-3.5 w-3.5 text-brand-amber shrink-0" />}
          </button>
        );
      })}
    </div>
  </div>
);
